<div style="display: flex; flex-direction: column; background-color: #303030;padding-left: 50px;">
    <div style="    font-size: small;
    font-weight: 600;
    margin: 5px;
    margin-left: 30px;">Feeling reported</div>
  <div style="display: flex; flex-direction: row;">
    <div style="width:50px; text-align: right; font-size: x-small;">Very bad</div>
    @for (item of [].constructor(this.LogSummary.Feeling_NoOfVeryBad); track item) {
      <div style="width: 5px; height: 10px; margin: 2px; background-color: red;"></div>
    }
  </div>
  <div style="display: flex; flex-direction: row;">
    <div style="width:50px; text-align: right; font-size: x-small;">Bad</div>
    @for (item of [].constructor(this.LogSummary.Feeling_NoOfBad); track item) {
      <div style="width: 5px; height: 10px; margin: 2px;background-color: orange;;"></div>
    }
  </div>
  <div style="display: flex; flex-direction: row;">
    <div style="width:50px; text-align: right; font-size: x-small;">OK</div>
    @for (item of [].constructor(this.LogSummary.Feeling_NoOfOK); track item) {
      <div style="width: 5px; height: 10px; margin: 2px;background-color: yellow;"></div>
    }
  </div>
  <div style="display: flex; flex-direction: row;">
    <div style="width:50px; text-align: right; font-size: x-small;">Good</div>
    @for (item of [].constructor(this.LogSummary.Feeling_NoOfGood); track item) {
      <div style="width: 5px; height: 10px; margin: 2px;background-color: greenyellow;"></div>
    }
  </div>
  <div style="display: flex; flex-direction: row;">
    <div style="width:50px; text-align: right; font-size: x-small;">Very good</div>
    @for (item of [].constructor(this.LogSummary.Feeling_NoOfVeryGood); track item) {
      <div style="width: 5px; height: 10px; margin: 2px;background-color: green;"></div>
    }
  </div>



</div>